import { api } from "../client";
import { DocumentOrderChangelog } from "../schema/DocumentOrderChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<DocumentOrderChangelog[]>;

export const getDocumentOrderChangelog = async (
  documentOrderId: number,
  config?: ApiRequestConfig
) => {
  return api.get<DocumentOrderChangelog[]>(
    `document_orders/${documentOrderId}/document_order_histories`,
    config
  );
};
